module.exports = __webpack_public_path__ + "img/8.9a450198.jpg";